import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export function useAuth() {
  const navigate = useNavigate();

  // 🟡 Synchronously get token and user info
  const rawLoginInfo = localStorage.getItem('login_info');
  const rawToken = localStorage.getItem('auth_token');

  let initialUserInfo = null;
  let initialAuthToken = null;
  let initialLoginUserId = null;

  try {
    const parsedLoginInfo = JSON.parse(rawLoginInfo);
    if (
      typeof parsedLoginInfo === 'object' &&
      parsedLoginInfo !== null &&
      rawToken &&
      rawToken.trim() !== ''
    ) {
      initialUserInfo = parsedLoginInfo;
      initialAuthToken = rawToken;
      initialLoginUserId = parsedLoginInfo.userId;
    }
  } catch (_) {
    // Fail silently
  }

  // 🔵 Initialize state with already-loaded values
  const [userInfo, setUserInfo] = useState(initialUserInfo);
  const [authToken, setAuthToken] = useState(initialAuthToken);
  const [loginUserId, setLoginUserId] = useState(initialLoginUserId);

  const clearAuth = useCallback(() => {
    setUserInfo(null);
    setAuthToken(null);
    setLoginUserId(null);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('login_info');
    localStorage.removeItem('auth_token');
    localStorage.removeItem('powerSyncToken');
    localStorage.removeItem('roleKey');
    localStorage.removeItem('entityId');

    clearAuth();
    /*navigate('/login');*/
    setTimeout(() => navigate('/login'), 100);
  }, [clearAuth, navigate]);

  return {
    userInfo,
    authToken,
    loginUserId,
    logout,
  };
}

